import { render } from "./Statistics.vue?vue&type=template&id=713ead47"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Statistics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "713ead47"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('713ead47', __exports__)) {
    api.reload('713ead47', __exports__)
  }
  
  module.hot.accept("./Statistics.vue?vue&type=template&id=713ead47", () => {
    api.rerender('713ead47', render)
  })

}


export default __exports__